export const Mine = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 -0.5 15 16"
      shape-rendering="crispEdges"
    >
      <metadata>
        Made with Pixels to Svg https://codepen.io/shshaw/pen/XbxvNj
      </metadata>
      <path
        stroke="#222428"
        d="M0 0h1M1 1h3M5 3h1M4 4h1M3 5h1M2 6h1M2 9h1M3 10h1M10 10h1M4 11h1M9 11h1M13 11h1M5 12h1M8 12h1M13 12h1M13 13h1M8 15h1M10 15h2"
      />
      <path
        stroke="#333436"
        d="M1 0h1M0 1h1M1 2h5M8 2h5M1 3h4M8 3h5M1 4h2M9 4h1M11 4h2M1 5h2M10 5h3M1 6h1M11 6h2M1 9h1M11 9h2M1 10h2M11 10h2M1 11h2M11 11h2M1 12h4M9 12h4M1 13h5M8 13h5M12 14h2M12 15h2"
      />
      <path stroke="#3d3e40" d="M2 0h1M0 2h1M0 3h1M0 4h1M9 14h3M14 15h1" />
      <path
        stroke="#4b4c4e"
        d="M3 0h2M7 2h1M7 3h1M6 4h3M10 4h1M0 5h1M6 5h1M9 5h1M0 6h1M10 6h1M0 7h1M7 7h1M10 7h2M0 8h1M7 8h4M0 9h1M9 9h2M14 13h1M5 14h4M14 14h1"
      />
      <path stroke="#616266" d="M5 0h2M14 11h1M14 12h1" />
      <path
        stroke="#727377"
        d="M7 0h8M14 1h1M14 2h1M14 3h1M14 4h1M7 5h2M14 5h1M7 6h1M9 6h1M14 6h1M8 7h2M12 7h1M14 7h1M14 8h1M14 9h1M0 10h1M14 10h1M0 11h1M0 12h1M0 13h1M0 14h5"
      />
      <path
        stroke="#16181e"
        d="M4 1h10M13 2h1M13 3h1M13 4h1M13 5h1M13 6h1M13 7h1M13 8h1M13 9h1M13 10h1M0 15h8M9 15h1"
      />
      <path
        stroke="#000000"
        d="M6 2h1M6 3h1M3 4h1M5 4h1M4 5h2M3 6h4M1 7h6M1 8h6M11 8h2M3 9h6M4 10h6M3 11h1M5 11h4M10 11h1M6 12h2M6 13h2"
      />
      <path stroke="#fbfbfb" d="M8 6h1" />
    </svg>
  );
};
